const controllers = require.context('.', true, /.coffee$/)
controllers.keys().forEach(controllers)
